module.exports = __webpack_public_path__ + "img/NewLogoGalpon.c555b7b5.png";